export class NetworkStatus {
    public static status = 'online';
}
